<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'en' ">Search - {{ term }} - {{ msg }}</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'es' ">Busca - {{ term }} - {{ msg }}</h1>
                <h1 class="font-weight-bold display-1 text-center " v-if="lang == 'pt' ">Busca - {{ term }} - {{ msg }}</h1>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/'+product.url_en"
                                v-if="lang=='en'"
                        >

                            <v-img
                                    v-if="product.img"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="product.img"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        @click="addProductCart(product.id)"
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/es/'+product.url_en"
                                v-if="lang=='es'"
                        >
                            <v-img
                                    v-if="product.img"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="product.img"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/pt/'+product.url_en"
                                v-if="lang=='pt'"
                        >
                            <v-img
                                    v-if="product.img"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="product.img"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                                <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                                <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                                <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                                <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        class="title"
                                        color="green"
                                        text
                                >
                                    ${{ product.price | number_format_real }}
                                </v-btn>
                                <v-btn
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                        @click="addProductCart(product.id)"
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            lang: { type: String },
            cartVisible: { type: Boolean },
        },
        metaInfo () {
            return {
                title: "PPS - Search ",
                meta: [
                    {description: 'PPS Brands - Search'},
                    {keywords: 'PPS Brands - Search'}
                ]
            }
        },
        data () {
            return {
                term:"",
                products:"",
                msg:""
            }
        },
        methods: {
            init() {
                var newTerm = window.location.search.slice(1).replace('g=','');
                if(newTerm != this.term){
                    this.term = newTerm;
                    var arr = {
                        search:this.term,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post("https://api.ppsbrands.com/store/search",arr).then(response => {
                        if(response.data.erro){
                            this.msg = "No products found."
                        }else{
                            this.products = response.data.data;
                            this.msg = response.data.msg[0];
                        }
                    });
                }
            }
        },
        mounted(){
            this.$emit('showCart');
            var self = this;
            setInterval(function(){
                    self.init();
                }, 500
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>